/**
 * Check if the text is only emoji.
 */
export const isTextEmojiOnly = (text: string): boolean => {
  const stringToTest = text.replace(/\s/g, "");
  const emojiOnlyRegex =
    /^(?:\p{Emoji_Presentation}|\p{Extended_Pictographic}|\p{Emoji}\uFE0F)+$/u;

  return stringToTest.length > 0 && emojiOnlyRegex.test(stringToTest);
};
